import React from 'react'

import EmailSignupForm from './EmailSignupForm'

const TicketNotification = () => (
  <EmailSignupForm
    action="/actions/business-logic/default/ticket-notification-signup/"
    successText={window.jsProps.strings.ticketNotificationSuccess}
  />
)

export default TicketNotification
